/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/IDE-exercise/v1.ts
 */

import { createValidator } from '../../helpers/validator';
export var IDEExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    hint: {
      type: 'string'
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    sample_code: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description: 'Path of the file to create.'
          },
          open: {
            type: 'boolean',
            default: false,
            description: 'Should we open the file by default?'
          },
          content: {
            type: 'string',
            default: '',
            description: 'Content of the file.'
          },
          permission: {
            type: 'number',
            default: 755,
            description: 'Unix permission of the file (755 = read/write access).'
          }
        },
        required: ['path']
      }
    },
    solution: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description: 'Path of the file to create.'
          },
          open: {
            type: 'boolean',
            default: false,
            description: 'Should we open the file by default?'
          },
          content: {
            type: 'string',
            default: '',
            description: 'Content of the file.'
          },
          permission: {
            type: 'number',
            default: 755,
            description: 'Unix permission of the file (755 = read/write access).'
          }
        },
        required: ['path']
      }
    },
    sct: {
      type: 'string',
      default: ''
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'instructions', 'language', 'pre_exercise_code', 'sample_code', 'sct', 'solution', 'title', 'xp'],
  definitions: {}
};
export var isValidIDEExerciseV1 = createValidator(IDEExerciseV1Schema);
export var IDEExerciseV1Definition = {
  schema: IDEExerciseV1Schema,
  validate: isValidIDEExerciseV1
};